const ITEMS = [
  "Kostka brukowa",
  "Łęczna",
  "Lublin",
  "Świdnik",
  "Płyty tarasowe",
  "Brukarstwo artystyczne",
  "Podjazdy",
  "Opaski wokół domu",
  "Palisady i obrzeża",
  "Łuszczów",
  "Cyców",
  "Podzamcze",
];

const Diamond = () => <span className="mx-8 inline-block h-2.5 w-2.5 rotate-45 bg-amber" aria-hidden="true" />;

const Marquee = () => (
  <div className="overflow-hidden border-y border-white/10 bg-graph py-5" data-testid="marquee">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center whitespace-nowrap" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="font-display flex items-center text-2xl font-bold uppercase tracking-wider text-pearl/80">
              {item}
              <Diamond />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
